const testIds = {
  CHAT_MODULE: 'savi-assistant-chat-module',
  COPILOT_WINDOW: 'savi-assistant-copilot-window',
  COPILOT_HEADER: 'savi-assistant-copilot-header',
  COPILOT_HEADER_CLOSE_BTN: 'savi-assistant-copilot-header-close-btn',
  COPILOT_ASIDE: 'savi-assistant-copilot-aside',
  COPILOT_ASIDE_EXPAND_BTN: 'savi-assistant-copilot-aside-expand-btn',
  REQUEST_PAGE: 'savi-assistant-request-page',
  CHAT_LEFT_PANEL: 'savi-assistant-chat-left-panel',
  CHAT_LEFT_PANEL_TRACE_BTN: 'savi-assistant-chat-left-panel-trace-btn',
  CHAT_LEFT_PANEL_CLOSE_BTN: 'savi-assistant-chat-left-panel-close-btn',
  CHAT_LEFT_PANEL_ESTIMATED_BTN: 'savi-assistant-chat-left-panel-estimated-btn',
  CHAT_LEFT_PANEL_WAYPOINT_EXPAND_BTN:
    'savi-assistant-chat-left-panel-waypoint-expand-btn',
  WAYPOINT_NAME: 'savi-assistant-waypoint-name',
  WAYPOINT_PROGRESS_CHIP: 'savi-assistant-waypoint-progress-chip',
  GEN_ACTION_ID: 'savi-assistant-shared-actions',
  GEN_UI_WRAPPER_ID: 'savi-assistant-shared-ui-wrapper',
  GEN_UI_WRAPPER_EXPAND_BTN: 'savi-assistant-ui-wrapper-expand-btn',
  GEN_UI_WRAPPER_COLLAPSE_BTN: 'savi-assistant-ui-wrapper-collapse-btn',
  GEN_UI_WRAPPER_CLOSE_BTN: 'savi-assistant-ui-wrapper-close-btn',
  GEN_TABLE_ID: 'savi-assistant-shared-table',
  GEN_SAFE_BOUNDARY_ERROR: 'savi-assistant-safe-boundary-error',
  GEN_REVIEW_CARD_ID: 'savi-assistant-review-card',
  GEN_PROMPT_INPUT_ID: 'savi-assistant-prompt-input',
  GEN_PROMPT_INPUT_ADD_FILES_BTN: 'savi-assistant-prompt-input-add-files-btn',
  GEN_PROMPT_INPUT_MIC_BTN: 'savi-assistant-prompt-input-mic-btn',
  GEN_PROMPT_INPUT_SUBMIT_BTN: 'savi-assistant-prompt-input-submit-btn',
  GEN_PROMPT_ID: 'savi-assistant-prompt',
  GEN_MODULE_HEADER_ID: 'savi-assistant-module-header',
  GEN_MODULE_HEADER_RESET_BTN: 'savi-assistant-module-header-reset-btn',
  GEN_MODULE_HEADER_CLOSE_BTN: 'savi-assistant-module-header-close-btn',
  GEN_MODULE_HEADER_MENU_BTN: 'savi-assistant-module-header-menu-btn',
  GEN_MARKDOWN_ID: 'savi-assistant-markdown',
  GEN_FORM_ID: 'savi-assistant-form',
  GEN_FORM_CONTINUE_BTN: 'savi-assistant-form-continue-btn',
  COMBINED_FORM_TITLE: 'savi-assistant-combined-form-title',
  COMBINED_FORM_CONTINUE_BTN: 'savi-assistant-combined-form-continue-btn',
  COMBINED_FORM_REFRESH_BTN: 'savi-assistant-combined-form-refresh-btn',
  COMBINED_FORM_ERROR: 'savi-assistant-combined-form-error',
  COMBINED_FORM_LOADER: 'savi-assistant-combined-form-loader',
  FORM_FORGE_CONTINUE_BTN: 'savi-assistant-form-forge-continue-btn',
  FORM_FORGE_LOADER: 'savi-assistant-form-forge-loader',
  FORM_FORGE_ERROR: 'savi-assistant-form-forge-error',
  FORM_FORGE_REFRESH_BTN: 'savi-assistant-form-forge-refresh-btn',
  FORM_FORGE_FORM: 'savi-assistant-form-forge-form',
  LIST_VIEWER_ACCESS_MODAL: 'savi-assistant-list-viewer-access-modal',
  LIST_VIEWER_APPLICATION_MODAL: 'savi-assistant-list-viewer-application-modal',
  LIST_VIEWER_ACCOUNT_OWNERS: 'savi-assistant-list-viewer-account-owners',
  LIST_VIEWER_SERVICE_ACCOUNT: 'savi-assistant-list-viewer-service-account',
  LIST_VIEWER_SERVICE_ACCOUNTS_MODAL:
    'savi-assistant-list-viewer-service-accounts-modal',
  LIST_VIEWER_ERROR_MODAL: 'savi-assistant-list-viewer-error-modal',
  LIST_VIEWER_CONTINUE_BTN: 'savi-assistant-list-viewer-continue-btn',
  LIST_VIEWER_EXPAND_BTN: 'savi-assistant-list-viewer-expand-btn',
  LIST_VIEWER_ACCESS_ITEM_BTN: 'savi-assistant-list-viewer-access-item-btn',
  LIST_VIEWER_APPLICATION_ITEM_BTN:
    'savi-assistant-list-viewer-application-item-btn',
  LIST_VIEWER_ACCOUNT_OWNERS_ITEM_BTN:
    'savi-assistant-list-viewer-account-owners-item-btn',
  LIST_VIEWER_SERVICE_ACCOUNT_ITEM_BTN:
    'savi-assistant-list-viewer-service-account-item-btn',
  CHAT_CENTER_PANEL: 'savi-assistant-chat-center-panel',
  CHAT_RIGHT_PANEL: 'savi-assistant-chat-right-panel',
  CHAT_PROMPT_INPUT: 'savi-assistant-chat-prompt-input',
  CHAT_SUBMIT_BTN: 'savi-assistant-chat-submit-btn',
  CHAT_STOP_BTN: 'savi-assistant-chat-stop-btn',
  CHAT_MESSAGE_USER: 'savi-assistant-chat-message-user',
  CHAT_MESSAGE_ASSISTANT: 'savi-assistant-chat-message-assistant',
} as const;

export default testIds;
